import { useState, useEffect } from 'react';
import { SolucoesSebraeService } from '../../services/solucoesSebraeService';

export const IncluirSolucoesModel = () => {
  const [availableTemas, setAvailableTemas] = useState([]);
  const [availableUFs, setAvailableUFs] = useState([]);
  const [ufResponse, setUfResponse] = useState([]);
  const [temasResponse, setTemasResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleFetchUfs = async () => {
    await SolucoesSebraeService.findUfs().then((resp) => {
      const tranformedResponse = resp
        .map((uf) => uf.sigla)
      setUfResponse(resp);
      setAvailableUFs(tranformedResponse);
    });
  };

  const handleFetchTema = async () => {
    await SolucoesSebraeService.getTemas().then((resp) => {
      const tranformedResponse = resp.data.map((t) => t.descricao);
      setTemasResponse(resp.data);
      setAvailableTemas(tranformedResponse);
    });
  };

  useEffect(() => {
    handleFetchUfs();
    handleFetchTema();
  }, []);

  return {
    isLoading,
    ufResponse,
    temasResponse,
    availableUFs,
    availableTemas,
    setIsLoading,
  };
};
